module.exports = __webpack_public_path__ + "img/cheerful_msg.cc82a5e7.png";